export const HEART_BEAT_PUBLIC_ROUTE = '/__/heart-beat';
